import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { CustomInput } from '../../interfaces/custom-input';
import { ChipComponent } from '../chip/chip.component';
import { DatePickerComponent } from '../forms/date-picker/date-picker.component';

@Component({
  selector: 'lib-custom-input-editor',
  imports: [
    MatFormFieldModule,
    TranslateModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    ChipComponent,
    DatePickerComponent
  ],
  templateUrl: './custom-input-editor.component.html',
  styleUrl: './custom-input-editor.component.scss',
  standalone: true
})

export class CustomInputEditorComponent implements OnInit {
  @Input() config!: CustomInput;
  @Input() fieldTypes: string[] = ["text", "number", "password", "select", "date", "checkbox"]

  defaultDate: string = new Date().toISOString();

  constructor() {
  }

  ngOnInit(): void {
    // Initialiser options si le type est select
    if (this.config.type === 'select' && !this.config.options) {
      this.config.options = [];
    }
  }

  toJsonKey(label: string) {
    let key = label.toLowerCase().trim();          // lowercase + trim spaces
    key = key.replace(/[^a-z0-9]+/g, '_');         // replace non-alphanumeric with underscores
    key = key.replace(/^_+|_+$/g, '');             // remove leading/trailing underscores
    if (/^[0-9]/.test(key)) key = '_' + key;       // prefix if starts with a number
    return key;
  }

  onLabelChanged() {
    this.config.name = this.toJsonKey(this.config.label)
  }

  addOption() {
    if (!this.config.options) {
      this.config.options = [];
    }

    const newOptionStr = String(this.config.newOption).trim();
    if (this.config.newOption && newOptionStr !== '') {

      if (!this.config.options.includes(newOptionStr)) {
        this.config.options.push(newOptionStr);
      }
      this.config.newOption = "";
    }
  }

  removeOption(option: string) {
    if (this.config.options) {
      this.config.options = this.config.options.filter((o: string) => o !== option);
    }
  }

  onDateChanged(newDate: string) {
    this.config.value = newDate;
  }

  getTypeIcon(type: string): string {
    const icons: { [key: string]: string } = {
      'text': 'text_fields',
      'number': 'pin',
      'password': 'lock',
      'select': 'list',
      'date': 'calendar_today',
      'checkbox': 'check_box'
    };
    return icons[type] || 'help';
  }
}
